import { VFC } from 'react';
import { NotFoundFooter } from '../not_found/components/NotFoundFooter';
import { OldValuesStepFooter } from './steps/old_values/Footer';
import { NewValuesStepFooter } from './steps/new_values/Footer';
import { DetailsStepFooter } from './steps/details/Footer';
import { ReviewStepFooter } from './steps/review/Footer';
import { ReplaceMeterStep } from './enums/replaceMeterSteps';

const MAP = {
  [ReplaceMeterStep.OldValues]: OldValuesStepFooter,
  [ReplaceMeterStep.NewValues]: NewValuesStepFooter,
  [ReplaceMeterStep.Details]: DetailsStepFooter,
  [ReplaceMeterStep.Review]: ReviewStepFooter,
} satisfies Record<ReplaceMeterStep, VFC>;

export const getFooterByStep = (newStep: ReplaceMeterStep): VFC => MAP[newStep] ?? NotFoundFooter;
